import { RESTOCK_WAITLIST_STATUS_LABELS } from "@/modules/restock-waitlist/domain/constants";
import type { RestockWaitlistStatus } from "@/modules/restock-waitlist/domain/types";

export type WaitlistStatusBadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "success";

export const RESTOCK_WAITLIST_STATUS_META: Record<
  RestockWaitlistStatus,
  {
    label: string;
    variant: WaitlistStatusBadgeVariant;
    className?: string;
  }
> = {
  waiting: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.waiting,
    variant: "secondary",
  },
  ready: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.ready,
    variant: "outline",
    className: "border-secondary/40 bg-secondary/15 text-secondary",
  },
  notified: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.notified,
    variant: "default",
  },
  converted: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.converted,
    variant: "outline",
    className: "border-leaf/40 bg-leaf/90 text-leaf-foreground",
  },
  expired: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.expired,
    variant: "destructive",
  },
  cancelled: {
    label: RESTOCK_WAITLIST_STATUS_LABELS.cancelled,
    variant: "outline",
  },
};

export function waitlistStatusLabel(status: RestockWaitlistStatus) {
  return RESTOCK_WAITLIST_STATUS_META[status]?.label ?? status;
}

export function getWaitlistStatusMeta(status: RestockWaitlistStatus) {
  return (
    RESTOCK_WAITLIST_STATUS_META[status] ?? {
      label: status,
      variant: "outline" as const,
    }
  );
}

export function parseImportSnapshot(snapshot: string | null) {
  if (!snapshot) return null;
  try {
    return JSON.parse(snapshot) as {
      stockOnHand?: number;
      incomingQuantity?: number;
      nearestExpectedAt?: string | null;
      orders?: Array<{
        importOrderNumber?: string;
        expectedArrivalDate?: string | null;
        remainingQuantity?: number;
      }>;
    };
  } catch {
    return null;
  }
}
